import React, { useEffect, useState } from "react";
import Typography from '@visa/vds/typography'
import Row from '@visa/vds/row';
import Grid from '@visa/vds/grid';
import Dialog from '@visa/vds/dialog';
import DialogCardBody from '@visa/vds/dialog-card-body';
import DialogCardHead from '@visa/vds/dialog-card-head';
import DialogCardHeadTitle from '@visa/vds/dialog-card-head-title';
import ButtonGroup from '@visa/vds/button-group';
import ButtonIcon from '@visa/vds/button-icon'
import MCSPagedTable from "components/MCSPagedTable";
import Icon from "@visa/vds/icon"
import Td from '@visa/vds/td';
import Tr from '@visa/vds/tr';
import { touService } from "services/tou.service";
import { DateHelper } from "_helpers/DateHelper";
import { PageHelper } from "_helpers/PageHelper";
import MCSLoading from "components/MCSLoading";
import { Link } from "@visa/vds";
import { TERMS_OF_USE } from "_constants/PageRoutes";

function TermsOfUseHistoryDialog ({isDisplay, setIsDisplay}) {
    let colHeaders = [
        { displayName: "ID", name: "id",orderable: true },
        { displayName: "Region", name: "regionCode", orderable: true},
        { displayName: "Version", name: "version", orderable: true},
        { displayName: "VSS Publication Date", name: "publicationDate", orderable: true },
        { displayName: "", name: "actions", orderable: false },
    ];
    const PAGE_SIZE = 10;
    const [touData, setTouData] = useState(null)
    const [touFetched, setTouFetched] = useState(false)
    const [touTotalPages, setTouTotalPages] = useState(0)
    const [totalCount, settotalCount] = useState(0)
    const [selectedPage, setSelectedPage] = useState(1)
    const [ordered, setOrdered] = useState('publicationDate')
    const [isDsc, setDsc] = useState(true)

    const handleTouHistoryPageChange = async (page, orderBy=ordered, dsc=isDsc) => {
        setTouFetched(false)
        let skipCount = PageHelper.GetSkipCount(PAGE_SIZE, page)
        const pagedTouHistory = await touService.GetTouHistory(skipCount, orderBy, dsc)
        if (pagedTouHistory) {
            setTouData(pagedTouHistory.items)
            settotalCount(pagedTouHistory.totalCount)
            setTouTotalPages(PageHelper.GetTotalCountToPages(PAGE_SIZE, pagedTouHistory.totalCount))
        }
        setTouFetched(true)
    }

    const sortData = async (orderBy = null, dsc = false) => {
        setTouFetched(false)
        handleTouHistoryPageChange(selectedPage, orderBy, dsc)
    }

    const fetchDataOnPageChange = (page) => {
        setSelectedPage(page)
        handleTouHistoryPageChange(page)
    }

    const openTou = (regionHtm, version) => {
        window.open(TERMS_OF_USE + `/v${version}/${regionHtm}`, "_blank")
    }

    useEffect(() => {
        setSelectedPage(1)
        handleTouHistoryPageChange(1)
    }, [])
    
    return (
        <Dialog
                aria-describedby="Terms of Use History"
                onExit={() => { }}
                open={isDisplay}
                titleId="dialog-account-info"
            >
            <DialogCardHead>
                <ButtonGroup direction="right">
                    <ButtonIcon
                        iconType="light-tiny"
                        onClick={() => {
                            setIsDisplay(false)
                        }}
                    >
                        <Icon name="close" />
                    </ButtonIcon>
                </ButtonGroup>
                <DialogCardHeadTitle id="dialog-title-verify-account-info"><Typography tag="h1">Terms Of Use History</Typography></DialogCardHeadTitle>
            </DialogCardHead>
            <DialogCardBody id="dialog-body-verify-account-info">
                <Grid>
                    <Row>
                        {touFetched ?  
                        <MCSPagedTable 
                            size={"compact"}
                            selectedPage={selectedPage} 
                            setSelectedPage={fetchDataOnPageChange} 
                            totalCount={totalCount}
                            totalPages={touTotalPages}
                            colHeaders={colHeaders}
                            ordered={ordered}
                            setOrdered={setOrdered}
                            sortData={sortData}
                            isDsc={isDsc}
                            setDsc={setDsc}
                            usePagination={true}
                            tableData={
                                touData && touData.map((row, key) => (
                                    <Tr key={key}>
                                        <Td>{row.id}</Td>
                                        <Td>{row.regionName}</Td>
                                        <Td>{row.version}</Td>
                                        <Td>{DateHelper.ToFormattedDate(row.publicationDate)}</Td>
                                        <Td>
                                            <Link onClick={() => openTou(row.regionHtm, row.version)}>View</Link>
                                        </Td>
                                    </Tr>
                                ))
                            }
                        >
                        </MCSPagedTable>
                        : <Row><MCSLoading /></Row>}
                    </Row>
                </Grid>
            </DialogCardBody>
        </Dialog>
    );
}

export default TermsOfUseHistoryDialog;
